export const PANEL_MODE = {
  CLOSED: 'closed',
  PANEL: 'panel',
  FULLPAGE: 'fullpage',
};

export default function normalizePanelMode(raw) {
  // No stored preference (fresh user) defaults to the side panel, matching the
  // pre-tri-state behaviour where the Data assistant was open by default.
  if (raw === null || raw === undefined || raw === 'opened' || raw === PANEL_MODE.PANEL) {
    return PANEL_MODE.PANEL;
  }
  if (raw === PANEL_MODE.FULLPAGE) {
    return PANEL_MODE.FULLPAGE;
  }
  // 'closed' and any unknown stored value collapse to closed.
  return PANEL_MODE.CLOSED;
}
